import { cn } from '@/hen-ui/utils';
import type { StudentLoansInlineVariant } from './types';

export function studentLoansInlineCardClasses(
  _variant: StudentLoansInlineVariant,
): string {
  return cn('w-full');
}

export function studentLoansInlineCardContentClasses(
  variant: StudentLoansInlineVariant,
): string {
  return cn(variant === 'slim' ? 'gap-md p-md' : 'gap-md p-lg');
}

export function studentLoansInlineRootClasses(
  _variant: StudentLoansInlineVariant,
): string {
  return cn('flex w-full min-w-0 flex-col gap-sm');
}

export function studentLoansInlineContentClasses(
  _variant: StudentLoansInlineVariant,
): string {
  return cn(
    'flex min-w-0 flex-col gap-sm md:flex-row md:items-center md:gap-lg',
  );
}

export function studentLoansInlinePartnerClasses(
  variant: StudentLoansInlineVariant,
): string {
  return cn(
    'min-w-0 shrink-0',
    variant === 'slim'
      ? 'flex flex-col gap-min md:pr-sm'
      : 'flex flex-col gap-xs md:w-40',
  );
}

export function studentLoansInlineCopyClasses(
  _variant: StudentLoansInlineVariant,
): string {
  return cn('min-w-0 flex-1 overflow-hidden');
}

export function studentLoansInlineDisclosureClasses(
  variant: StudentLoansInlineVariant,
): string {
  return cn('min-w-0', variant === 'slim' && 'pt-xxs');
}
